var exports = {
  "kL": "xe7b6e3d6--1ff554--container",
  "iE": "xe7b6e3d6--1ff554--wrapper",
  "DD": "xe7b6e3d6--1ff554--title",
};

module.exports = exports;
